import { Avatar } from '@mui/material'

export default function OrderUserAvatar({ url }) {
	return (
		<Avatar
			src={url}
			sx={{ width: 48, height: 48, mr: 2, border: '1px solid #ccc' }}
			imgProps={{ style: { objectFit: 'cover' } }}
		/>
	)
}

